import http from '@core/fetch'
export default {
  //本月结算单
  getDetailApi: body =>
    http('/p/wedding/Admin/APIHotelSettleOrder/Detail', { body }),

  //历史结算单列表
  historyListApi: body =>
    http('/p/wedding/Admin/APIHotelSettleOrder/HistoryList', { body }),

  //支付
  payApi: body =>
    http.post(' /p/wedding/Admin/APIHotelSettleOrder/Pay', { body }),

  //流水列表
  cashApi: body =>
    http('/p/wedding/Admin/APIHotelSettleOrder/CashFlowList', { body }),

  //成交总额
  walletApi: body =>
    http('/p/wedding/index.php/Admin/APIHotelOrderWallet/wallet_list', { body })
}
